import React from "react";
import api from "../../../api";
import {notification} from "antd";

export function useManageItems(items, getItems, onSuccessEdit, onSuccessCreate) {
    const [editData, setEditData] = React.useState(null)

    function onEditItem(id) {
        const item = items.find((item) => item.id === id)
        setEditData(item)
        onSuccessEdit()
    }

    async function onCreate(values) {
        try {
            await api.post("virtual-product-categories", values)

            notification.success({ message: "Категория добавлена" })
            onSuccessCreate()
            getItems()
        } catch (error) {
            console.log("Ошибка добавления", error)
            notification.error({ message: "Ошибка добавления" })
            throw error
        }
    }

    async function onSaveEdit(values, id) {
        try {
            await api.post(`virtual-product-categories/${id}`, values)

            notification.success({ message: "Категория изменена" })
            getItems()
        } catch (error) {
            console.log("Ошибка изменения", error)
            notification.error({ message: "Ошибка изменения" })
            throw error
        }
    }

    async function onDelete(id) {
        try {
            await api.delete(`virtual-product-categories/${id}`)

            notification.success({ message: "Категория удалена" })
            getItems()
        } catch (error) {
            console.log("Ошибка удаления", error)
            notification.error({ message: "Ошибка удаления" })
            throw error
        }
    }

    function resetData() {
        setEditData(null)
    }

    return { editData, resetData, onSaveEdit, onCreate, onDelete, onEditItem }
}